// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__35iv5","upload":"Small_upload__kWL3e","imageWrap":"Small_imageWrap__1koAH","removeBtn":"Small_removeBtn__3lkjl"};